// Suppress benign ResizeObserver errors
export const suppressResizeObserverError = () => {
  const resizeObserverLoopErr = 'ResizeObserver loop completed with undelivered notifications.';
  const resizeObserverLoopErrRe = /^[^(ResizeObserver loop completed with undelivered notifications)]/;
  
  // Store the original error handler
  const originalError = window.onerror;
  
  window.onerror = function(message, source, lineno, colno, error) {
    if (typeof message === 'string' && (message === resizeObserverLoopErr || resizeObserverLoopErrRe.test(message))) {
      // Suppress this specific error
      return true;
    }
    
    // Call the original error handler if it exists
    if (originalError) {
      return originalError(message, source, lineno, colno, error);
    }
    
    return false;
  };
  
  // Also handle unhandledrejection events that might contain this error
  window.addEventListener('error', (e) => {
    if (e.message === resizeObserverLoopErr) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
  });
};